<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight - 100"
      border
      @edit-closed="reassign"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('table_label_order_data') || '所属订单数据' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderByDepCode="{ row }">
        <dep-cascader
          size="small"
          ref="dep"
          :lastValue.sync="row.orderByDepCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  computed: {},
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { orderCustCode: '', orderByDepCode: '' },
        -1
      )
      await $itemTable.setActiveCell(newRow, 'orderCustCode')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.reassign()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      // 校验重复数据
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        const keys = tableData.map(
          (item) => `${item.orderCustCode}-${item.orderByDepCode}`
        )
        const reKeys = keys.filter(
          (i) => keys.indexOf(i) !== keys.lastIndexOf(i)
        )
        if (reKeys && reKeys.length) {
          this.$message.error(
            `${this.$l('table_please_check') ||
              '存在重复的客户和业务部门，请检查。'}`
          )
          return false
        }
      }
      return !(await this.$refs.itemTable.validate(true))
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.reassign()
    },
    reassign() {
      this.v_tableData = this.getTableData()
    },
  },
}
</script>
